import React from 'react';
import CrudManager from './CrudManager';
import { adminApi } from '../../lib/api';

const FIELDS = [
  { name: 'code', label: 'Customer-facing Code', required: true, placeholder: 'e.g. SAVE100 (case-insensitive)' },
  { name: 'name', label: 'Internal Promotion Name', required: true, placeholder: 'e.g. Spring $100 Off' },
  { name: 'description', label: 'Customer Description (optional)', placeholder: 'Shown when the code is applied' },
  {
    name: 'discount_type', label: 'Discount Type', type: 'select', required: true,
    options: [
      { value: 'percent', label: 'Percentage (%)' },
      { value: 'fixed', label: 'Fixed amount ($)' },
    ],
  },
  { name: 'discount_value', label: 'Discount Value', type: 'number', help: 'e.g. 10 for 10%, or 100 for $100' },
  { name: 'max_discount', label: 'Max Discount Cap ($)', type: 'number', help: '0 = no cap (for percentage codes)' },
  { name: 'min_spend', label: 'Minimum Eligible Spend ($)', type: 'number', help: '0 = no minimum' },
  { name: 'eligible_services', label: 'Eligible Services', type: 'list', help: 'One per line: glambooth, photography, videography. Empty = all.' },
  { name: 'eligible_upgrades', label: 'Eligible Upgrades', type: 'list', help: 'Exact upgrade names, one per line. Empty = all discountable upgrades.' },
  { name: 'starts_at', label: 'Starts At (ISO)', placeholder: '2026-07-01T00:00:00+00:00 (optional)' },
  { name: 'expires_at', label: 'Expires At (ISO)', placeholder: '2026-08-01T23:59:59+00:00 (optional)' },
  { name: 'usage_limit', label: 'Overall Usage Limit', type: 'number', help: '0 = unlimited' },
  { name: 'per_email_limit', label: 'Per-email Usage Limit', type: 'number', help: '0 = unlimited' },
  { name: 'active', label: 'Active', type: 'checkbox', checkboxLabel: 'Code is active' },
  { name: 'notes', label: 'Internal Notes', type: 'textarea', placeholder: 'Private admin notes' },
];

const PromoCodesAdmin = () => (
  <CrudManager
    title="Promotions & Promo Codes"
    description="Create and manage discount codes. Codes are validated on the server and counted as redeemed only when a booking is confirmed."
    api={adminApi.promoCodes}
    fields={FIELDS}
    itemLabel="Promo Code"
    renderItem={(p) => (
      <div>
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          <h3 className="text-[#EADBC8] font-bold font-mono">{p.code}</h3>
          <span className={`text-xs px-2 py-0.5 rounded-full font-bold ${p.active ? 'bg-green-500/20 text-green-400' : 'bg-gray-500/20 text-gray-400'}`}>
            {p.active ? 'ACTIVE' : 'INACTIVE'}
          </span>
        </div>
        <p className="text-[#C5A880] text-sm mb-1">{p.name}</p>
        <p className="text-gray-400 text-xs">
          {p.discount_type === 'percent' ? `${p.discount_value}% off` : `$${p.discount_value} off`}
          {p.max_discount ? ` (max $${p.max_discount})` : ''}
          {p.min_spend ? ` · min $${p.min_spend}` : ''}
          {(p.eligible_services?.length ? ` · ${p.eligible_services.join(', ')}` : ' · all services')}
        </p>
        <p className="text-gray-500 text-xs mt-1">
          Redeemed: {p.used_count || 0}{p.usage_limit ? ` / ${p.usage_limit}` : ''}
        </p>
      </div>
    )}
  />
);

export default PromoCodesAdmin;
